export default __webpack_public_path__ + "static/media/nurita.930864c4.jpg";